import React, { useState } from "react";
import { MessageCircle, Phone, Mail, MapPin, Clock, CheckCircle2 } from "lucide-react";
import { company } from "../mock";

const ContactForm = () => {
  const [form, setForm] = useState({ nome: "", telefono: "", email: "", veicolo: "", cf: "", indirizzo: "", messaggio: "" });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    // Invia la richiesta su WhatsApp con messaggio precompilato (frontend only)
    const lines = [
      "*Richiesta preventivo motore*",
      `Nome: ${form.nome}`,
      `Telefono: ${form.telefono}`,
      `Email: ${form.email}`,
      `Marca/Modello/P5: ${form.veicolo}`,
      form.cf ? `C.F./P.IVA: ${form.cf}` : "",
      form.indirizzo ? `Indirizzo spedizione: ${form.indirizzo}` : "",
      "",
      form.messaggio,
    ].filter((l) => l !== "" || true);
    const text = encodeURIComponent(lines.filter(Boolean).join("\n"));
    window.open(`${company.whatsappLink}?text=${text}`, "_blank");
    setSent(true);
  };

  return (
    <section id="preventivo" className="bg-[#f4f6f9] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Info */}
          <div>
            <h2 className="font-display text-[#0f2846] text-3xl md:text-4xl font-bold">Richiedi il tuo preventivo gratuito</h2>
            <div className="w-24 h-1 bg-[#e8464a] mt-4 rounded-full" />
            <p className="text-slate-500 mt-5">Compila il modulo o contattaci direttamente. Ti rispondiamo in giornata con un preventivo dettagliato e senza impegno.</p>
            <div className="mt-8 space-y-4">
              {company.phones.map((p, i) => (
                <a key={i} href={`tel:+39${p.raw}`} className="flex items-center gap-4 group">
                  <span className="w-11 h-11 rounded-xl bg-[#0f2846] flex items-center justify-center text-white"><Phone size={19} /></span>
                  <span className="font-semibold text-[#0f2846] group-hover:text-[#e8464a] transition-colors">{p.display}</span>
                </a>
              ))}
              <a href={`mailto:${company.email}`} className="flex items-center gap-4 group">
                <span className="w-11 h-11 rounded-xl bg-[#0f2846] flex items-center justify-center text-white"><Mail size={19} /></span>
                <span className="font-semibold text-[#0f2846] group-hover:text-[#e8464a] transition-colors break-all">{company.email}</span>
              </a>
              <div className="flex items-center gap-4">
                <span className="w-11 h-11 rounded-xl bg-[#0f2846] flex items-center justify-center text-white"><MapPin size={19} /></span>
                <span className="font-medium text-slate-600">{company.address}</span>
              </div>
              <div className="flex items-center gap-4">
                <span className="w-11 h-11 rounded-xl bg-[#0f2846] flex items-center justify-center text-white"><Clock size={19} /></span>
                <span className="font-medium text-slate-600">{company.hours}</span>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-7 md:p-8">
            {sent ? (
              <div className="h-full flex flex-col items-center justify-center text-center py-10">
                <CheckCircle2 size={54} className="text-[#22c35e]" />
                <h3 className="font-display font-bold text-[#0f2846] text-xl mt-4">WhatsApp aperto!</h3>
                <p className="text-slate-500 mt-2">Grazie {form.nome || ""}. Invia il messaggio precompilato su WhatsApp: ti ricontatteremo al più presto con il tuo preventivo.</p>
                <button onClick={() => { setSent(false); setForm({ nome: "", telefono: "", email: "", veicolo: "", cf: "", indirizzo: "", messaggio: "" }); }} className="mt-6 text-[#e8464a] font-semibold text-sm">Invia un'altra richiesta</button>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4">
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-600 mb-1.5">Nome e cognome</label>
                    <input required value={form.nome} onChange={set("nome")} className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-[#0f2846] focus:ring-2 focus:ring-[#0f2846]/10 transition" placeholder="Mario Rossi" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-600 mb-1.5">Telefono</label>
                    <input required value={form.telefono} onChange={set("telefono")} className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-[#0f2846] focus:ring-2 focus:ring-[#0f2846]/10 transition" placeholder="333 1234567" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-600 mb-1.5">Email</label>
                  <input type="email" required value={form.email} onChange={set("email")} className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-[#0f2846] focus:ring-2 focus:ring-[#0f2846]/10 transition" placeholder="nome@email.com" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-600 mb-1.5">Marca, modello e codice motore (P5)</label>
                  <input value={form.veicolo} onChange={set("veicolo")} className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-[#0f2846] focus:ring-2 focus:ring-[#0f2846]/10 transition" placeholder="Es. Fiat Ducato 2.3 - 198A3000" />
                </div>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-600 mb-1.5">C.F./P.IVA <span className="text-slate-400 font-normal">(opzionale)</span></label>
                    <input value={form.cf} onChange={set("cf")} className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-[#0f2846] focus:ring-2 focus:ring-[#0f2846]/10 transition" placeholder="Codice fiscale o P.IVA" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-600 mb-1.5">Indirizzo di spedizione <span className="text-slate-400 font-normal">(opzionale)</span></label>
                    <input value={form.indirizzo} onChange={set("indirizzo")} className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-[#0f2846] focus:ring-2 focus:ring-[#0f2846]/10 transition" placeholder="Via, CAP, città" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-600 mb-1.5">Messaggio</label>
                  <textarea rows={4} value={form.messaggio} onChange={set("messaggio")} className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-[#0f2846] focus:ring-2 focus:ring-[#0f2846]/10 transition resize-none" placeholder="Scrivi qui la tua richiesta..." />
                </div>
                <button type="submit" className="w-full flex items-center justify-center gap-2 bg-[#22c35e] hover:bg-[#1da851] text-white font-semibold py-3.5 rounded-lg transition-all hover:-translate-y-0.5 shadow-lg shadow-[#22c35e]/25">
                  <MessageCircle size={17} /> Invia richiesta su WhatsApp
                </button>
                <p className="text-center text-slate-400 text-xs">La tua richiesta si apre su WhatsApp · Rispondiamo in giornata</p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
